import { render, staticRenderFns } from "./distributor.modal.vue?vue&type=template&id=4844c8dc&"
import script from "./distributor.modal.vue?vue&type=script&lang=js&"
export * from "./distributor.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports